import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { LOYALTY_ACTION_TYPE } from "./loyalty.action";
import { LoyaltyBalance, LoyaltyHistoryResponse, LoyaltyState } from "./loyalty.model";

const INITIAL_STATE: LoyaltyState = {
	history: undefined,
	monthlyHistory: undefined,
	balance: undefined,
	levels: undefined,
};

export function loyaltyReducer(state = INITIAL_STATE, action: ActionWithPayload): LoyaltyState {
	switch (action.type) {
		case LOYALTY_ACTION_TYPE.getBalanceSuccess: {
			return updateState(state, {
				balance: action.payload,
			});
		}
		case LOYALTY_ACTION_TYPE.clearHistory: {
			return updateState(state, {
				history: undefined,
			});
		}
		case LOYALTY_ACTION_TYPE.getHistorySuccess: {
			const payload: LoyaltyHistoryResponse = action.payload;
			return updateState(state, {
				history: {
					details: [
						...((state.history && state.history.details) || []),
						...payload.page.map((responseDetail) => ({
							date: responseDetail.createdDate,
							points: responseDetail.amount,
							type: responseDetail.operationType,
						})),
					],
					hasMore: payload.pageSize * (1 + payload.pageIndex) < payload.totalItemCount,
					pageIndex: payload.pageIndex,
				},
			});
		}
		case LOYALTY_ACTION_TYPE.getMonthlyHistorySuccess: {
			return updateState(state, {
				monthlyHistory: action.payload.page,
			});
		}
		case LOYALTY_ACTION_TYPE.getBrandLoyaltyLevelsSuccess: {
			return updateState(state, {
				levels: action.payload,
			});
		}
		case LOYALTY_ACTION_TYPE.exchangePointsSuccess: {
			return updateState(state, {
				balance: {
					...(state.balance as LoyaltyBalance),
					redeemablePoints: state.balance!.redeemablePoints - action.payload,
				},
			});
		}
		default:
			return state;
	}
}
